@if (isQuickLogin) {
  <dcr-card [headline]="person.displayName" (click)="quickLogin.emit(person)" class="cursor-pointer">
    <div slot="header-action">
      <div class="relative">
        <dcr-inline-icon-button
          icon="navigation:more_vert"
          aria-label="Meer acties"
          [attr.id]="'quick-' + person.id"
          (click)="prevent($event)"
        ></dcr-inline-icon-button>
        <dcr-menu [anchor]="'quick-' + person.id">
          <dcr-menu-item
            type="button"
            label="Naar het platform"
            leading-icon="actions:rocket_launch"
            (click)="quickLogin.emit(person)"
          ></dcr-menu-item>
          <dcr-divider></dcr-divider>
          <dcr-menu-item
            type="button"
            label="Vergeet mij"
            leading-icon="actions:lock_reset"
            (click)="forgetAboutMe.emit(person)"
          ></dcr-menu-item>
        </dcr-menu>
      </div>
    </div>
    <dcr-avatar slot="avatar" show-initials [imageUrl]="person.avatar" [firstName]="person.firstName" [lastName]="person.name"></dcr-avatar>
  </dcr-card>
}

@if (isAddNew) {
  <dcr-card headline="Code" type="button" color="secondary" (click)="userCardClicked.emit()">
    <dcr-icon size="xl" icon="device:password" slot="avatar"></dcr-icon>
  </dcr-card>
}

@if (isQRLogin) {
  <dcr-card headline="QR" type="button" color="tertiary" (click)="userCardClicked.emit()">
    <dcr-icon size="xl" icon="communicate:qr_code_2" slot="avatar"></dcr-icon>
  </dcr-card>
}

@if (isLeerIDLogin) {
  <dcr-card headline="LeerId" type="button" (click)="userCardClicked.emit()">
    <dcr-icon size="xl" icon="external:leerid" slot="avatar"></dcr-icon>
  </dcr-card>
}

@if (isQuestiLogin) {
  <dcr-card headline="Questi" type="button" (click)="userCardClicked.emit()">
    <dcr-icon size="xl" icon="external:questi" slot="avatar"></dcr-icon>
  </dcr-card>
}
